/* eslint no-console: 0*/
import React from 'react';
import PageAuthorize from '../../../security/PageAuthorize';
//import Datetime from 'react-datetime';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class adminTestFeatures extends React.Component {
  constructor( props ){
    super( props );
    this.state = {dateValue:'2017-01-03',hasError:false};

    //this.onChange = this.onChange.bind( this );
    this.testBugsnag = this.testBugsnag.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  testBugsnag(){
    const Bugsnag = this.props.bugsnag;
    //let oldBugsnagreleaseStage = Bugsnag.releaseStage;
    //Bugsnag.releaseStage = "AdminTestFeatures";
    Bugsnag.beforeNotify = function( payload ) {
      return true;
    };
    console.log( Bugsnag );
    Bugsnag.notify( 'Admin has used the features page to test Bugsnag is reporting' );
    //Bugsnag.releaseStage = oldBugsnagreleaseStage;
    if( Bugsnag.config.releaseStage.toLowerCase() !== 'staging' || Bugsnag.config.releaseStage.toLowerCase() !== 'production' ){
      Bugsnag.beforeNotify = function( payload ) {
        return false;
      };
    }
  }

  render() {
    if( this.state.hasError === false ){
      return (
        <PageAuthorize groups={['Administrators']} >
          <div style={{margin:'auto', width: '50%', padding:'10px', position:'absolute',top:'50px'}}>
            <div>
              <div>
                <button value={this.state.testDate} onChange={this.onChange} onClick={this.testBugsnag} style={{margin:'auto', width: '50%'}}> Test Bugsnag </button>
              </div>
            </div>
          </div>
        </PageAuthorize>
      );
    } else {
      return (
        <div>
          <span>Error: {this.state.error}</span>
          <span>Info: {this.state.info}</span>
        </div>
      );
    }
  }
}


export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( adminTestFeatures ) );



// WEBPACK FOOTER //
// ./src/content/admin/admintest/adminTestFeatures.js